<template>
  <div class="edit-profilebox add-new-memberbox savingaccount-formbox">
    <ul class="breadcrumbs-list">
      <a  @click="backButton"><li>Investment</li></a>
      <a  @click="depositeDashbord"><li>&nbsp;>&nbsp;Private Investment Dashboard</li></a>
      <a  @click="depositeAccounts"><li>&nbsp;>&nbsp;ESOP</li></a>

      <li>&nbsp;>&nbsp;ESOP</li>
    </ul>
    <h4 class="welcome-text">ESOP</h4>
    <div>
      <div class="edit-profilebox-detail">
        <v-form
          ref="form"
          id="saving_account"
          @submit.prevent
          class="login-form-box register-page"
          lazy-validation
        >
            <h4>Enter Details</h4>
            <v-row >
              <v-col xs="12" md="6" class="member_relation_box col" v-for="formAttr in formAttributes" :key="formAttr.id">
                <label class="member-label" v-if="formAttr['name'] =='current_balance'">{{formAttr['label']}} As On {{currentDate | moment("DD MMM, Y")}}</label>
                <label class="member-label" v-else>{{formAttr['label']}} </label>
                <div v-if="formAttr['type'] == 'select' && formAttr['name'] !='nominee'">
                  <v-select
                    ref="form_attrs"
                    :name="formAttr['name']" 
                    :v-model="formAttr['name']"
                    :items="(formAttr['name']=='beneficiary_name') ? beneficiary_name :[]"
                    item-value="id"
                    item-text="name"
                    :rules="formAttr['is_required'] ==true ? [v => !!v || 'Field is required']:[]"
                    @change='setMasterData(formAttr["name"], $event)'
                    :placeholder="formAttr['place_holder']"
                  ></v-select>
                </div>
                <div v-else-if="formAttr['type'] == 'input' && formAttr['name'] == 'company_name'" >
                    <v-text-field
                    :name="formAttr['name']"
                    :ref="formAttr['name']" 
                    :rules="formAttr['is_required'] == false ? [ v => !v || /^(?=.*[a-z])[a-zA-Z0-9 ]+$/.test(v) || 'Field must be alphanumeric or alpha']:[]"
                    :v-model="formAttr['name']"
                    :placeholder="formAttr['place_holder']"
                   
                    ></v-text-field> 
                </div>
                <div v-else-if="formAttr['type'] == 'input' && formAttr['name'] == 'no_of_grants'">
                    <v-text-field
                    :name="formAttr['name']"
                    :ref="formAttr['name']" 
                    :rules="formAttr['name'] == 'no_of_grants' ? [v => !!v || 'Field is required', v => /^\d*\.?\d*$/.test(v) || 'Field must be numeric'] : []"
                    :v-model="formAttr['name']"
                    :placeholder="formAttr['place_holder']"
                    @input="calculateAmounts()"
                    ></v-text-field> 
                    <a @click="appendGrantsFields" class="add-newbox" v-if="formAttr['name'] == 'no_of_grants'" style="margin-top:6px;">
                    Add Grants Details</a>
                </div>
                <div v-else-if="formAttr['type'] == 'date'" class="dob-box">
                  <Datepicker
                    :name="formAttr['name']" 
                    ref="form_attrs"
                    :v-model="formAttr['name']"
                    format="dd MMM, yyyy"
                    :placeholder="formAttr['place_holder']"
                  ></Datepicker>
                </div>
              </v-col>
            </v-row>
            <v-row v-if="emi_details.length != 0" v-for="emiList in emi_details" :key="emiList.id">
              <v-col xs="12" md="12" class="member_relation_box col esop-addform-box">
                <v-card class="boxs">
                  <h4>Grant {{emiList.grantnumber }}</h4>
                  <div class="close-icon">
                    <v-img
                      max-height="20"
                      max-width="20"
                      src="../../../../assets/images/delete.png"
                      @click="removeGrantDetail(emiList.grantnumber)"
                    ></v-img>
                  </div>
                  <v-row class="esop-addform-box-detail">
                    <v-col xs="6" md="6">
                      <label class="member-label">Grant Date</label>
                      <div class="dob-box">
                        <Datepicker
                          class="no-click"
                          format="dd MMM, yyyy"
                          :value="emiList.grantdate"
                        ></Datepicker>
                      </div>
                    </v-col>
                    <v-col xs="6" md="6">
                      <label class="member-label">Vesting Date</label>
                      <div class="dob-box">
                        <Datepicker
                          class="no-click"
                          format="dd MMM, yyyy"
                          :value="emiList.vestigedate"
                          @selected="setExciseDate($event)"
                        ></Datepicker>
                      </div>
                    </v-col>
                    <v-col xs="6" md="6">
                      <label  class="member-label">Exercise Date</label>
                      <div class="dob-box">
                        <Datepicker
                          class="no-click"
                          format="dd MMM, yyyy"
                          :value="emiList.excercisedate"
                           :disabledDates="disabledDates"
                        ></Datepicker>
                      </div>
                    </v-col>
                    <v-col xs="6" md="6">
                      <label class="member-label">Exercise Price</label>
                      <div class="rupee-icon">
                        <v-text-field
                        readonly
                        :value="emiList.excerciseprice"
                        ></v-text-field> 
                      </div>
                    </v-col>
                    <v-col xs="6" md="6">
                      <label class="member-label">Share Alloted</label>
                      <div>
                        <v-text-field
                        readonly
                        :value="emiList.sharealloted"
                        ></v-text-field> 
                      </div>
                    </v-col>
                    <v-col xs="6" md="6">
                      <label class="member-label">Market Price / Fair Value</label>
                      <div class="rupee-icon">
                        <v-text-field
                        readonly
                        :value="emiList.market_fairvalue"
                        ></v-text-field> 
                      </div>
                    </v-col>
                    <v-col xs="6" md="6">
                      <label class="member-label">No. of Share Exercised</label>
                      <div>
                        <v-text-field
                        readonly
                        :value="emiList.shareexcercised"
                        max='200'
                        
                        ></v-text-field> 
                      </div>
                    </v-col>
                    <v-col xs="6" md="6">
                      <label class="member-label">Market Value</label>
                      <div class="rupee-icon">
                        <v-text-field
                        readonly
                        :value="emiList.totalvalue"
                        ></v-text-field> 
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
            <span
              v-bind:class="{'error-messagebox-login': isAddClassServerError}"
              id="server_side_error"
              >{{serverError}}</span
            >
            <v-row class="buttonbox">
              <v-btn class="blue-border-btn" @click="depositeAccounts"> Cancel </v-btn>
              <v-btn
                class="blue-btn"
                @click="submit"
                :disabled="!isFormValid"
              >
                Save
              </v-btn>
            </v-row>


            <v-form ref="grantForm" lazy-validation>
              <v-row justify="center">
                <v-dialog v-model="dialog" persistent max-width="730px" class="login-form-box esop-modal-formbox">
                  <v-card>
                    <v-card-title>
                      <span class="text-h5"></span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" md="6" class="member_relation_box col">
                            <label>Grant Date</label>
                            <div class="dob-box">
                              <Datepicker
                                name="grant-date" 
                                ref="grant-date"
                                v-model="grantDate"
                                format="dd MMM, yyyy"
                                placeholder="Grant date"
                                @selected="disableGrantDate($event)"
                              ></Datepicker>
                            </div>
                          </v-col>
                          <v-col cols="12" md="6" class="member_relation_box col">
                            <label>Vesting Date</label>
                            <div class="dob-box">
                              <Datepicker
                                name="vesting-date" 
                                ref="vesting-date"
                                v-model="vestingDate"
                                format="dd MMM, yyyy"
                                placeholder="Vesting date"
                                :disabledDates="disabledGrandDates"
                                @selected="exerciseDateBound($event)"
                              ></Datepicker>
                            </div>
                          </v-col>
                          <v-col cols="12" md="6" class="member_relation_box col">
                            <label>Exercise Date</label>
                            <div class="dob-box">
                              <Datepicker
                                name="Exercise-date" 
                                ref="Exercise-date"
                                v-model="exerciseDate"
                                format="dd MMM, yyyy"
                                placeholder="Exercise date"
                                :disabledDates="disabledDates"
                              ></Datepicker>
                            </div>
                          </v-col>
                          <v-col cols="12" md="6" class="member_relation_box col">
                            <label>Exercise Price Per Share</label>
                            <div class="rupee-icon">
                              <v-text-field
                                v-model="exercisePrice"
                                placeholder="Enter exercise per share"
                                :rules="rules"
                              ></v-text-field>
                            </div>
                          </v-col>
                          <v-col cols="12" md="6" class="member_relation_box col">
                            <label>No. of Share Alloted</label>
                            <div>
                              <v-text-field
                                v-model="noOfShareAlloted"
                                placeholder="Enter no of shares alloted"
                                :rules="[v => /^\d*\.?\d*$/.test(v) || 'Field must be numeric',v => !!v || 'Field is required']"
                                
                                @input = noOfShareAllotedFun($event)
                              ></v-text-field>
                            </div>
                          </v-col>
                          <v-col cols="12" md="6" class="member_relation_box col" v-if ="is_no_of_share_exercised">
                            <label>No. of Share Exercised</label>
                            <div>
                              <v-text-field
                                v-model="noOfShareExercised"
                                placeholder="Enter no of shares exercised"
                                
                                @input="calculateAmounts"
                              ></v-text-field>
                            </div>
                          </v-col>
                          <v-col cols="12" md="6" class="member_relation_box col">
                            <label>Market Price / Fair value</label>
                            <div class="rupee-icon">
                              <v-text-field
                                v-model="marketFairPrice"
                                placeholder="Enter market price / fair value"
                                :rules="rules"
                                @input="calculateAmounts"
                              ></v-text-field>
                            </div>
                          </v-col>
                          <v-col cols="12" md="6" class="member_relation_box col">
                            <label>Market Value</label>
                            <div class="rupee-icon">
                              <v-text-field
                                readonly
                                v-model="marketValue"
                                placeholder="Market value"
                              ></v-text-field>
                            </div>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="addGrants">Add</v-btn>
                      <v-btn color="blue darken-1" text @click="closeGrantDialog">Close</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-row>
            </v-form>

          </v-form>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import {required, email, minLength, sameAs, isAlphanumeric, alpha, numeric, maxLength} from "vuelidate/lib/validators";
import { Auth } from 'aws-amplify';
import { SAVE_PRIVATE_INVESTMENT_DETAIL, GET_EMPLOYEE_FORM, GET_CITY, GET_LOCATION_LIST, GET_PRIVATE_INVESTMENT_FORM_DETAIL } from "../../../../store/actions.type";
import { isEmpty } from 'lodash';
export default {
    components: {
      Datepicker,
    },
    data: () => ({
      submitted: false,
      is_no_of_share_exercised:true,
      serverError:'',
      isAddClassServerError:false,
      formAttributes:'',
      isFormValid:false,
      formAttr:'',
      location:[],
      property_type:[],
      sub_type:[],
      familyMember:[],
      nominee:[],
      ownership:[],
      state:[],
      city:[],
      addMoreField:[],
      other_form_field:[],
      form_id:'',
      beneficiary_name:[],
      currentDate: new Date().setDate(new Date().getDate()),
      allow_nominee:1,
      current_value_value:'',
      dialog: false,
      grantDate:'',
      vestingDate:'',
      exerciseDate:'',
      exercisePrice:'',
      noOfShareExercised:'',
      marketFairPrice:'',
      marketValue:'',
      noOfShareAlloted:'',
      emi_details:[],
      grantObj:{},
      disabledDates: {
        from: new Date(),
        to: new Date()
      },

      disabledGrandDates:{
          to: new Date()
      },

      rules:[v =>  /^\d{0,8}[.]?\d{1,2}$/ .test(v) || 'Field must be numeric',v => !!v || 'Field is required'],

      max_exercised:'',
      
    }), 
    created (){
      Fire.$on("loadData", () => {
        this.getAddFormData();
      });
    },
    mounted(){
      if (isEmpty(this.$store.getters.getEmployeeForm)) {
        this.getAddFormData();
      }else{
        this.allow_nominee = this.$store.getters.getEmployeeForm.allow_nominee;
        this.form_id = this.$store.getters.getEmployeeForm.data.form_id;
        this.formAttributes = this.$store.getters.getEmployeeForm.data.form_attributes.fields;
        let masterDataArr = this.$store.getters.getEmployeeForm.data.master_data;
        masterDataArr.forEach(element => {
          if (element.beneficiaryName) {
            element.beneficiaryName.forEach(data => {
              this.beneficiary_name.push({'id':data.id, 'name':data.name});
            });
          }
        });
      }
    },
    methods: {
      noOfShareAllotedFun(e){
        this.max_exercised = e
      },
      exerciseDateBound(e){

        if(new Date()<  new Date(e)){
          this.rules = []
          this.is_no_of_share_exercised = false;
        }
        else{
          this.rules = [v =>  /^\d{0,8}[.]?\d{1,2}$/ .test(v) || 'Field must be numeric',v => !!v || 'Field is required']
          this.is_no_of_share_exercised = true;
        }
        this.disabledDates.to = e;
        this.exerciseDate = '';
      },
      backButton(){
        this.checkFormData = [];
        let getFormData = document.querySelector("#saving_account");
        var formData = new FormData(getFormData)
        for (const [key, value] of formData.entries()) {
          if (value) {
            this.checkFormData.push(value);
          }
        }
        this.checkFormData.length > 0 ?  swal
        .fire({
          title: "Your data will be cleared. Are you sure you want to close this?",
          showCancelButton: true,
          confirmButtonColor: `#051d42`,
          confirmButtonText: `YES`,
          cancelButtonColor: `#f19700`,
        }).then(result => {
          
          if (result.isConfirmed) {
            this.$router.push({ name: 'Investment'})
          }
        }) : this.$router.push({ name: 'Investment'});
      },
      depositeAccounts(){
        this.checkFormData = [];
        let getFormData = document.querySelector("#saving_account");
        var formData = new FormData(getFormData)
        for (const [key, value] of formData.entries()) {
          if (value) {
            this.checkFormData.push(value);
          }
        }
        this.checkFormData.length > 0 ?  swal
        .fire({
          title: "Your data will be cleared. Are you sure you want to close this?",
          showCancelButton: true,
          confirmButtonColor: `#051d42`,
          confirmButtonText: `YES`,
          cancelButtonColor: `#f19700`,
        }).then(result => {
          if (result.isConfirmed) {
            this.$router.push({ name: "private-dashboard", params: { tab: 'tab-1' }}).catch(()=>{});
          }
        }) : this.$router.push({ name: "private-dashboard", params: { tab: 'tab-1' }}).catch(()=>{});
      },
      appendGrantsFields(){
        let getFormData = document.querySelector("#saving_account");
        if(getFormData.no_of_grants.value && this.$refs.form.validate()){
          if(getFormData.no_of_grants.value <6)
          {
            //if(getFormData.no_of_grants.value == this.emi_details.length){
              // swal.fire({
              //   title: '',
              //   text: "You have already added "+getFormData.no_of_grants.value+" emi's.",
              //   icon: 'warning',
              //   showCancelButton: false,
              //   confirmButtonColor: '#051d42',
              //   confirmButtonText: 'OK',
              // }).then((result) => {
              //   if (result.isConfirmed) {
              //     return;
                  
              //   }
              // })
            //}else{
              this.dialog = true;
            //}
          }
          else
          {
            swal.fire({
              title: '',
              text: "You can add maximum 5 grants.",
              icon: 'warning',
              showCancelButton: false,
              confirmButtonColor: '#051d42',
              confirmButtonText: 'OK',
            }).then((result) => {
              if (result.isConfirmed) {
                return;
                
              }
            })
          }

        }
        else{
          swal.fire({
            title: '',
            text: "Please enter valid no. of grants.",
            icon: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#051d42',
            confirmButtonText: 'OK',
          }).then((result) => {
            if (result.isConfirmed) {
              return;
              
            }
          })
        }
      },
      addGrants(){
        if(this.$refs.grantForm.validate()){
          
          let getFormData = document.querySelector("#saving_account");
          if( new Date()<  new Date(this.grantDate) && this.exerciseDate !='' &&  this.noOfShareExercised ==''){
              swal
                .fire({
                  title: "No of shares exercised can't be empty!",
                  showCancelButton: false,
                  confirmButtonColor: `#051d42`,
                  confirmButtonText: `OK`,
                  cancelButtonColor: `#f19700`,
                })
          }
          else{
            this.grantObj = {
              'grantnumber' : parseInt(this.emi_details.length+1),
              'excerciseprice' : this.exercisePrice ? this.exercisePrice : 0,
              'sharealloted' : this.noOfShareAlloted ? this.noOfShareAlloted : 0,
              'shareexcercised' : this.noOfShareExercised ? this.noOfShareExercised : 0,
              'market_fairvalue' : this.marketFairPrice ? this.marketFairPrice : 0,
              'totalvalue' : this.marketValue ? this.marketValue : 0,
              'grantdate' : this.grantDate,
              'vestigedate' : this.vestingDate,
              'excercisedate' : this.exerciseDate,
            }
            this.emi_details.push(this.grantObj)
            this.no_of_grants = this.emi_details.length+1
            this.closeGrantDialog();
          }
           
        }

      },
      closeGrantDialog(){
        this.grantObj = {};
        this.exercisePrice = '';
        this.noOfShareAlloted = '';
        this.noOfShareExercised = '';
        this.marketFairPrice = '';
        this.marketValue = '';
        this.grantDate = '';
        this.vestingDate = '';
        this.exerciseDate = '';
        this.dialog = false;
      },
      removeGrantDetail(grantnumber){
        let i = 0;
        this.emi_details = this.emi_details.filter(item => item.grantnumber != grantnumber)
        this.emi_details.forEach(data => {
          data.grantnumber = ++i;
        })
      },
      submit(e) {
        let getFormData = document.querySelector("#saving_account");
        let additionalText = "";
        if(getFormData.no_of_grants.value > 1){
           additionalText = "s";
        }
        if(this.emi_details.length != parseInt(getFormData.no_of_grants.value)){
          swal.fire({
            title: '',
            text:"Please enter details for "+ getFormData.no_of_grants.value +" ESOP"+additionalText,
            icon: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#051d42',
            confirmButtonText: 'OK',
          }).then((result) => {
            if (result.isConfirmed) {
              return;
              
            }
          })
          return;
        }
        this.checkFormData = [];
        var formData = new FormData(getFormData)
        for (const [key, value] of formData.entries()) {
          if (value) {
            this.checkFormData.push(value);
          }
        }
        if (this.checkFormData.length > 0) {
            this.submitted = true;
            this.$loading(true)
            let jsonObject = []
            let nominee    = []
            let i=0;
            for (const [key, value] of formData.entries()) {
              if(key == 'beneficiary_name'){
                jsonObject.push({"key":key, "values":parseInt(value)})
              }
              else{
                jsonObject.push({"key":key, "values":value})
              }
              i++;
            }
            let collected_data = {"collected_data":jsonObject,"emi_details":this.emi_details};
            let cognito_idp = atob(localStorage.getItem('cognito_idp'));
            this.$store.dispatch(SAVE_PRIVATE_INVESTMENT_DETAIL, {
              data: {
                aws_cognito_id: cognito_idp,
                form_id:this.form_id,
                account_owner:getFormData.beneficiary_name.value,
                form_detail:JSON.stringify(collected_data),
              },
              api: 'save-private-investment-detail',
            }).then(() => {
               this.savingAccountList();
                this.$loading(false)
                Toast.fire({
                    icon: 'success',
                    title: "ESOP form submitted successfully"
                  })
              this.$router.push({ name: "private-dashboard", params: { tab: 'tab-1' }});
            }).catch(() => {
                this.$loading(false)
            })

        }else{
          return;
        }
      },
      setMasterData:function(attr_type, val){
        // let masterDataArr = this.$store.getters.getEmployeeForm.data.master_data;
        //  if (attr_type == 'beneficiary_name') {
        //   let i = 0;
        //   this.nominee = [];
        //   masterDataArr['0']['FamilyMember'].forEach(
        //     familyMember => {
        //       if (parseInt(val) != parseInt(familyMember['id'])) {
        //           //if (familyMember.id != '') {
        //             this.nominee.push(familyMember.name);
        //          // }
        //       }
        //       i++;
        //   });
        // }
      },
      depositeDashbord(){
        this.checkFormData = [];
        let getFormData = document.querySelector("#saving_account");
        var formData = new FormData(getFormData)
        for (const [key, value] of formData.entries()) {
          if (value) {
            this.checkFormData.push(value);
          }
        }
        this.checkFormData.length > 0 ?  swal
        .fire({
          title: "Your data will be cleared. Are you sure you want to close this?",
          showCancelButton: true,
          confirmButtonColor: `#051d42`,
          confirmButtonText: `YES`,
          cancelButtonColor: `#f19700`,
        }).then(result => {
          
          if (result.isConfirmed) {
            this.$router.push({ name: "private-dashboard"})
          }
        }) : this.$router.push({ name: "private-dashboard"});
      },

      calculateAmounts(){
          console.log('no of share', this.noOfShareExercised)
          if(this.max_exercised !='' && parseInt(this.noOfShareExercised) > parseInt(this.max_exercised)){
                 swal
                .fire({
                  title: "No of shares exercised can't be more than no of shares allotted!",
                  showCancelButton: false,
                  confirmButtonColor: `#051d42`,
                  confirmButtonText: `OK`,
                  cancelButtonColor: `#f19700`,
                })

                this.noOfShareExercised = ''
          }
          else{
            this.isFormValid = this.$refs.form.validate()
            if(this.marketFairPrice && this.noOfShareExercised){
              this.marketValue = (this.marketFairPrice * this.noOfShareExercised);
            }
            else{
              this.marketValue = ''
            }
          }
            
      },

      savingAccountList(){
        let cognito_idp = atob(localStorage.getItem('cognito_idp'));
        let user_name =  this.$store.getters.getUserDetails.user_name;
        let selected_value = this.$store.getters.getUserDetails.selected_value;
        this.$loading(true);
        this.$store.dispatch(GET_PRIVATE_INVESTMENT_FORM_DETAIL, {
          data: {
            aws_cognito_id: cognito_idp,
            user_name:user_name,
            member_id:selected_value,
          },
          api: "get-private-investment-form-detail",
        })
        .then(() => {
          Fire.$emit("updatePrivateInvestmentData");
          this.$loading(false);
        }).catch(() => {
          this.$loading(false);
        });
      },
      getAddFormData (){
        if(this.$store.getters.getUserDetails.user_name){  
          this.$loading(true)
            let cognito_idp = atob(localStorage.getItem('cognito_idp'));
            let user_name =  this.$store.getters.getUserDetails.user_name;
            let selected_value = this.$store.getters.getUserDetails.selected_value;
            this.$store.dispatch(GET_EMPLOYEE_FORM, {
              data: {
                aws_cognito_id: cognito_idp,
                user_name:user_name,
                form_type: 28,
              },
              api: "get-private-investment-form",
            })
            .then(() => {
            this.allow_nominee = this.$store.getters.getEmployeeForm.allow_nominee;
            this.form_id = this.$store.getters.getEmployeeForm.data.form_id;
            this.formAttributes = this.$store.getters.getEmployeeForm.data.form_attributes.fields;
            let masterDataArr = this.$store.getters.getEmployeeForm.data.master_data;
            masterDataArr.forEach(element => {
              if (element.beneficiaryName) {
                element.beneficiaryName.forEach(data => {
                  this.beneficiary_name.push({'id':data.id, 'name':data.name});
                });
              }
            });
            this.$loading(false)
          })
          .catch(function (error) {
             console.log(error)
          });  
        }           
      },

      setExciseDate(e){

        this.is_no_of_share_exercised = true
        disabledDates.to  = new Date(e)


      },


      disableGrantDate(e){
        this.disabledGrandDates.to =  new Date(e)
      }  
    }
};
</script>
